import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

interface Category {
  id: number;
  name_ar: string;
  name_en: string;
  slug: string;
  icon: string | null;
  type: string;
}

const categoryColors: Record<string, string> = {
  sheep: 'bg-green-100 text-green-600',
  camels: 'bg-amber-100 text-amber-600',
  goats: 'bg-blue-100 text-blue-600',
  cattle: 'bg-red-100 text-red-600',
  horses: 'bg-purple-100 text-purple-600',
  birds: 'bg-sky-100 text-sky-600',
};

const categoryEmojis: Record<string, string> = {
  sheep: '🐑',
  camels: '🐪',
  goats: '🐐',
  cattle: '🐄',
  horses: '🐎',
  birds: '🐦',
};

const CategoriesPage: React.FC = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await api.get('/categories');
        setCategories(res.data.data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  if (loading) {
    return (
      <div className="max-w-site mx-auto px-4 py-20 text-center">
        <p className="text-gray-400">جاري التحميل...</p>
      </div>
    );
  }

  return (
    <div className="max-w-site mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">التصنيفات</h1>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/categories/${cat.slug}`}
            className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition text-center group"
          >
            <div className={`w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center text-3xl ${categoryColors[cat.slug] || 'bg-gray-100 text-gray-500'}`}>
              {categoryEmojis[cat.slug] || '📦'}
            </div>
            <h3 className="font-bold text-gray-800 group-hover:text-primary-500 transition">{cat.name_ar}</h3>
            <p className="text-xs text-gray-400 mt-1">{cat.name_en}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default CategoriesPage;
